import { SpeedLimitService } from './SpeedLimitService';

class AppSpeedLimitService extends SpeedLimitService {
    /**
     * 
     * @param {import('@themost/common').ApplicationBase} app 
     */
    constructor(app) {
        super(app);
    }

    getServiceName() {
        return '@universis/janitor#AppSpeedLimitService';
    }

    getServiceContainer() {
        return this.getApplication() && this.getApplication().container;
    }
}

export { AppSpeedLimitService };